import { resetCrispSession } from "@/services/CrispChatService"
import { logout as keycloakLogout } from "@/auth/keycloak"

export const logout = async () => {
  resetCrispSession()

  await keycloakLogout()
}
